import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { environment } from "../../environment.enum";

export class CloudStorageService {


    static async getEnvDownloadUrl(path: string, errorCallback?: (error) => void) {
        try {
            const storage = getStorage();
            const pathReference = ref(storage, path);
            // for local environments we mock the getDownloadUrl to simply return the path and load data from assets
            const getDownloadEnvAdjusted = CloudStorageService.adjustToEnv(path);
            const downloadUrl = await getDownloadEnvAdjusted(pathReference);
            return downloadUrl;
        }
        catch (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        }
    }
    static async downloadFile(path: string, errorCallback?: (error) => void) {
        try {
            const storage = getStorage();
            const pathReference = ref(storage, path);
            // for local environments we mock the getDownloadUrl to simply return the path and load data from assets
            const getDownloadEnvAdjusted = CloudStorageService.adjustToEnv(path);
            const downloadUrl = await getDownloadEnvAdjusted(pathReference);
            const res = await fetch(downloadUrl);
            return res;
        }
        catch (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        }
    }

    private static adjustToEnv(path: string) {
        let getDownloadEnvAdjusted = getDownloadURL;
        if (process.env.REACT_APP_ENVIRONMENT === environment.local) {
            getDownloadEnvAdjusted = () => {
                return Promise.resolve(path);
            };
        }
        return getDownloadEnvAdjusted;
    }

}